const css = `._stats_146yc_1 {
  display: flex;
  gap: 24px;
  flex-direction: column;
  flex: 1;
}
._statsDetails_146yc_7 {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
  justify-content: center;
}
._statsDetailsLabel_146yc_15 {
  color: var(--secondary-text-color);
  text-align: center;
}
._statsSection_146yc_19 {
  border-bottom: 1px solid var(--border-color);
  display: flex;
  flex-direction: column;
  gap: 24px;
  flex: 1;
  padding-bottom: 24px;
}
._statsSection_146yc_19:last-child {
  border-bottom: 0 none transparent;
  padding-bottom: 0;
}
._statsSectionHeader_146yc_31 {
  align-items: center;
  display: flex;
  font-weight: 500;
  justify-content: center;
  font-size: 1em;
  gap: 8px;
}
._statsSectionSection_146yc_39 {
  display: flex;
  flex: 1;
  flex-direction: column;
  font-size: 0.8em;
  gap: 8px;
}
._statsSectionSectionHeader_146yc_46 {
  align-items: center;
  display: flex;
  font-weight: 500;
  justify-content: center;
}
._statsSectionSectionContents_146yc_52 {
  display: grid;
}
._statsColumnsDonutOverlay_146yc_55 {
  position: relative;
}
._statsColumnsDonutOverlayText_146yc_58 {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
._statsColumnsDonut_146yc_55 > svg {
  height: auto;
  max-width: 100px;
  width: 100%;
}
._statsColumnsStrikesByZone_146yc_69 {
  align-items: center;
  display: grid;
  grid-template-columns: 1fr 2fr 1fr;
  height: 100%;
  justify-content: center;
}
._statsColumnsStrikesByZoneBorderRow_146yc_76 {
  align-items: center;
  display: grid;
  border-bottom: 1px solid var(--border-color);
  height: 100%;
  justify-content: center;
}
._statsColumnsStrikesByZoneBorderRow_146yc_76:nth-last-child(-n+3) {
  border-bottom: 0 none transparent;
}
._statsColumnsFighter_146yc_86 {
  align-items: center;
  display: flex;
}
._statsColumnsFighter_146yc_86[data-fighter=home] {
  justify-content: start;
}
._statsColumnsFighter_146yc_86[data-fighter=away] {
  justify-content: end;
}
._statsColumnsFighter_146yc_86 > svg {
  max-height: 200px;
  height: auto;
  max-width: 100px;
  width: 100%;
}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
export default {
  "stats": "_stats_146yc_1",
  "statsDetails": "_statsDetails_146yc_7",
  "statsDetailsLabel": "_statsDetailsLabel_146yc_15",
  "statsSection": "_statsSection_146yc_19",
  "statsSectionHeader": "_statsSectionHeader_146yc_31",
  "statsSectionSection": "_statsSectionSection_146yc_39",
  "statsSectionSectionHeader": "_statsSectionSectionHeader_146yc_46",
  "statsSectionSectionContents": "_statsSectionSectionContents_146yc_52",
  "statsColumnsDonutOverlay": "_statsColumnsDonutOverlay_146yc_55",
  "statsColumnsDonutOverlayText": "_statsColumnsDonutOverlayText_146yc_58",
  "statsColumnsDonut": "_statsColumnsDonut_146yc_55",
  "statsColumnsStrikesByZone": "_statsColumnsStrikesByZone_146yc_69",
  "statsColumnsStrikesByZoneBorderRow": "_statsColumnsStrikesByZoneBorderRow_146yc_76",
  "statsColumnsFighter": "_statsColumnsFighter_146yc_86"
};